module.exports = __webpack_public_path__ + "static/media/Galdisa_habanero_corn.ec3201ff.pdf";